import { RadioGroupValues } from '../../typings'
import * as LocalTexts from './intl'

export const getRadioGroupTypes = (): RadioGroupValues => [
  {
    label: LocalTexts.getFromOperationsText(),
    value: 'fromOperations',
    className: 'pendo-simulation__import-from-operation',
    trackId: 'simulation-from-operations',
  },
  {
    label: LocalTexts.getFromArchivedText(),
    value: 'fromArchived',
    className: 'pendo-simulation__import-from-archived',
    trackId: 'simulation-from-archived',
  },
  {
    label: LocalTexts.getFromScratchText(),
    value: 'fromScratch',
    className: 'pendo-simulation__start-from-scratch',
    trackId: 'simulation-from-scratch',
  },
]
